import { useSelect } from "@refinedev/antd";
import { useCreate } from "@refinedev/core";
import { Form, Input, Modal, Select } from "antd";
import { IBook } from "interfaces";
import { genAudioStatus } from "utils";

type Props = {
  isShow: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

export default function ModalBulkRestartAudioTask({
  isShow,
  onClose,
  onSuccess,
}: Props) {
  const [form] = Form.useForm();
  const { mutate: mutateRestart, isLoading: isRestart } = useCreate({});

  const { selectProps: bookSelectProps } = useSelect<IBook>({
    resource: "book",
    optionLabel: "name",
    optionValue: "_id",
    filters: [
      {
        field: "type",
        operator: "eq",
        value: "audio",
      },
    ],
    queryOptions: {
      enabled: isShow,
    },
    onSearch: (q) => {
      const filters: any[] = [];

      filters.push({
        field: "q",
        operator: "eq",
        value: q,
      });

      return filters;
    },
  });

  const onFinish = (values: any) => {
    mutateRestart(
      {
        dataProviderName: "defaultV2",
        resource: `audio-tasks/bulk-restart`,
        values: {
          bookId: values.bookId,
          status: values.status,
        },
      },
      {
        onSuccess: () => {
          onSuccess();
          form?.resetFields();
        },
      }
    );
  };

  return (
    <Modal
      title="Bulk Restart Audio Task"
      open={isShow}
      onCancel={onClose}
      okButtonProps={{
        htmlType: "submit",
        form: "form-bulk-restart-audio-task",
      }}
      centered
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        id="form-bulk-restart-audio-task"
      >
        <Form.Item label="Book" name="bookId">
          <Select {...bookSelectProps} allowClear />
        </Form.Item>

        <Form.Item label="Status" name="status" initialValue={["error"]}>
          <Select options={genAudioStatus} mode="multiple" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
